/**
 * Created by Svetoslav Kostadinov on 1/27/2016.
 */

// Module Imports
import baseComponent from "../baseComponent";

let PromiseIE = require('es6-promise-polyfill').Promise;

const validateSettings = [
  {
    setting: "content",
    isRequired: true,
    validate: "type",//a type or a value
    possibleValues: ["string", "object"],
    errorMessage: ["GDK Consolidated Summary : Content must be defined and set to a DOM selector or Node"]
  },
  {
    setting: "autoLoad",
    isRequired: false,
    validate: "type",
    possibleValues: ["boolean"],
    errorMessage: ["GDK Consolidated Summary : autoLoad must be a boolean"]
  },
  {
    setting: "loadPlog",
    isRequired: false,
    validate: "type",
    possibleValues: ["function"],
    errorMessage: ["GDK Consolidated Summary : loadPlog must be a function"]
  }
];

/**
 * Consolidated Summary Component: This is integrated informative component for GEICO Counselors. Main purpose is to ease counselors
 * work by displaying various information on selected policy holder.
 */
class ConsolidatedSummary {

  /**
   * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
   * @param {string|Object} content
   *  A reference to Consolidated Summary Component.
   *
   * @param {function} loadPlog
   *  A callback function that gets fired with a return of a promise function
   *
   *  @param {boolean} [autoLoad=true]
   *  Use if you want prevent consolidated summary to auto load when instantiated
   *
   */

  constructor(options) {

    this._internalVars = {
      node: null,   //used for the current node
      consolidatedSummary: null    //holds reference to the consolidated Summary node;
    };

    this._defaults = {
      initialTabOpen: 1,
      autoLoad: true,
      loadPlog: function () { //Return an empty promise
        return new PromiseIE((resolve, reject) => {
          resolve();
        });
      }
    };

    if (options && typeof options === "object") {
      this._options = baseComponent.extendDefaults(this._defaults, options);
    }

    if (baseComponent.validateSettings(this._options, validateSettings)) {
      this._internalVars.contentType = baseComponent.getContentType(this);
      setLocalVars.call(this);
      setEvents.call(this);
      init.call(this);
    }
  }


  /**
   * Global method to switch the Consolidated Summary component on and off
   * @param initFix
   */
  toggleConsolidatedSummary(initFix) {
    var node = this._internalVars.node;
    if (initFix) {
      if (!document.querySelector('#wrapper').classList.contains('consolidated-summary-enabled')) {
        document.querySelector('#wrapper').classList.add('consolidated-summary-enabled');
      }
      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
        if (!document.querySelector('#to-top').classList.contains('consolidated-summary-enabled')) {
          document.querySelector('#to-top').classList.add('consolidated-summary-enabled');
        }
      }


    } else {
      toggleComponent.call(this);
    }
  }
}

/**
 * Initializing method
 */
function init() {

  // make sure the #wrapper don't have the .pinned-consolidated-summary class;
  document.querySelector('#wrapper').classList.remove('pinned-consolidated-summary');

  if (this._options.autoLoad && this._internalVars.node.classList.contains('hidden')) {
    this.toggleConsolidatedSummary();
  } else if (!this._options.autoLoad && !this._internalVars.node.classList.contains('hidden')) {
    this.toggleConsolidatedSummary();
  } else if (this._options.autoLoad && !this._internalVars.node.classList.contains('hidden')) {
    this.toggleConsolidatedSummary(true);
  }
  if (this._internalVars.node.classList && this._internalVars.node.classList.contains('extended')) {
    this._internalVars.node.classList.remove('extended');
  }
  if (!this._internalVars.plogComponent.classList || !this._internalVars.plogComponent.classList.contains('extended')) {
    this._internalVars.plogComponent.classList.add('hidden');
  }

  /* Instantiate the tabs */
  openInitialTab.call(this);

}

/**
 * method to set events for the component
 */
function setEvents() {

  let node = this._internalVars.node;
  let wrapper = this._internalVars.wrapper;

  /* Tabs */
  let tabs = this._internalVars.verticalTabs.querySelectorAll('.tab');
  let panels = this._internalVars.verticalTabs.querySelectorAll('.panel');

  /* PLOG Controls */
  let plogBtn = this._internalVars.plogBtn;
  let plog = this._internalVars.plogComponent;
  let plogSendBtn = this._internalVars.plogSendBtn;
  let plogForm = this._internalVars.plogForm;
  /*PLOG Window Controls */
  let plogResizeBtn = this._internalVars.plogComponent.querySelector(".plogResizeBtn");
  let plogMinimizeBtn = this._internalVars.plogComponent.querySelector(".plogMinimizeBtn");
  let options = this._options;

  // On mouse click behavior
  wrapper.addEventListener("click", function () {
    node.classList.add("extended");
    if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
      if (!document.querySelector('#to-top').classList.contains('consolidated-summary-extended')) {
        document.querySelector('#to-top').classList.add('consolidated-summary-extended');
      }
    }
  }, false);
  // On mouse enter behavior
  // wrapper.addEventListener("mouseenter", function () {
  //if (!document.querySelector('body').classList.contains('no-scroll')){
  //    document.querySelector('body').style.top = -(document.querySelector('body').scrollTop) + "px";
  //    document.querySelector('body').classList.add('no-scroll');
  //}
  //document.querySelector('body').style.position = "fixed";
  //document.querySelector('body').style.overflowY = "none";
  // }, false);
  // On mouse leave behavior
  wrapper.addEventListener("mouseleave", function () {
    node.classList.remove("extended");
    if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
      if (document.querySelector('#to-top').classList.contains('consolidated-summary-extended')) {
        document.querySelector('#to-top').classList.remove('consolidated-summary-extended');
      }
    }
    //if (document.querySelector('body').classList.contains('no-scroll')){
    //    document.querySelector('body').removeAttribute('style');
    //    document.querySelector('body').classList.remove('no-scroll');
    //}
    //document.querySelector('body').style.position = "static";
    //document.querySelector('body').style.overflowY = "visible";
  }, false);

  // implement "pinned" functionality
  node.querySelector(".consolidated-summary-pin").addEventListener("click", function () {
    if (!node.classList.contains("pinned")) {
      document.querySelector('#wrapper').classList.add('pinned-consolidated-summary');
      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
        if (!document.querySelector('#to-top').classList.contains('consolidated-summary-pinned')) {
          document.querySelector('#to-top').classList.add('consolidated-summary-pinned');
        }
      }
      if (document.querySelector('.docked-real-time-message-wrapper') !== null && document.querySelector('.docked-real-time-message-wrapper') !== 'undefined') {
        let dockedMsgArray = document.querySelectorAll('.docked-real-time-message-wrapper');
        Array.prototype.forEach.call(dockedMsgArray, (element) => {
          if (!element.classList.contains('con-sum-pinned')) {
            if (element.hasAttribute('id')) {
              element.classList.add('con-sum-three-hundred-fix');
            }
            element.classList.add('con-sum-pinned');
          }
        });

      }
      node.classList.add("pinned");
    } else {
      document.querySelector('#wrapper').classList.remove('pinned-consolidated-summary');
      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
        if (document.querySelector('#to-top').classList.contains('consolidated-summary-pinned')) {
          document.querySelector('#to-top').classList.remove('consolidated-summary-pinned');
        }
      }
      if (document.querySelector('.docked-real-time-message-wrapper') !== null && document.querySelector('.docked-real-time-message-wrapper') !== 'undefined') {
        let dockedMsgArray = document.querySelectorAll('.docked-real-time-message-wrapper');
        Array.prototype.forEach.call(dockedMsgArray, (element) => {
          if (element.classList.contains('con-sum-pinned')) {
            if (element.hasAttribute('id')) {
              element.classList.remove('con-sum-three-hundred-fix');
            }
            element.classList.remove('con-sum-pinned');
          }
        });

      }
      node.classList.remove("pinned");
    }
  });

  // implement the vertical Tabs functionality
  let eventName = "click";
  if ("ontouchstart" in document.documentElement) {
    eventName = "touchstart";
  }
  Array.prototype.forEach.call(tabs, (element) => {
    element.addEventListener(eventName, tabClickHandler.bind(this));
  });


  plogBtn.addEventListener("click", function (e) {
    e.preventDefault();
    options.loadPlog().then(function () {
      // hide Policy Notes
      if (!plog.classList.contains("hidden")) {
        plog.classList.add("hidden");
        if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
          if (document.querySelector('#to-top').classList.contains('plog-enabled')) {
            document.querySelector('#to-top').classList.remove('plog-enabled');
          }
        }
      } else {
        // Display Policy Notes
        plog.classList.remove("hidden");
        if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
          if (!document.querySelector('#to-top').classList.contains('plog-enabled')) {
            document.querySelector('#to-top').classList.add('plog-enabled');
          }
        }
      }
    });
  });

  plogMinimizeBtn.addEventListener("click", function () {

    if (!plog.classList.contains("hidden")) {
      if (plog.classList.contains("maximized")) {
        plog.classList.remove("maximized");
      }
      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
        if (!node.classList.contains('extended') && document.querySelector('#to-top').classList.contains('consolidated-summary-extended')) {
          document.querySelector('#to-top').classList.remove('consolidated-summary-extended');
        }
        if (!node.classList.contains("pinned") && document.querySelector('#to-top').classList.contains('consolidated-summary-pinned')) {
          document.querySelector('#to-top').classList.remove('consolidated-summary-pinned');
        }
        if (document.querySelector('#to-top').classList.contains('plog-enabled')) {
          document.querySelector('#to-top').classList.remove('plog-enabled');
        }
      }
      plog.classList.add("hidden");
    } else {
      plog.classList.remove("hidden");
    }
  });
  plogResizeBtn.addEventListener("click", function () {
    if (!plog.classList.contains("maximized")) {
      if (node.classList && node.classList.contains("extended")) {
        node.classList.remove("extended");
      }
      if (node.classList && node.classList.contains("pinned")) {
        document.querySelector('#wrapper').classList.remove('pinned-consolidated-summary');
        node.classList.remove("pinned");
      }
      plog.classList.add("maximized");
    } else {
      plog.classList.remove("maximized");
    }
  });
}

/* Tabs Methods */

/**
 * tabClickHandler()
 * Opens tab content for clicked tab and hides the rest
 */
function tabClickHandler(element) {
  let currentNode = element.currentTarget;
  //get index of clicked tab
  let index = [].indexOf.call(this._internalVars.tabs, currentNode);
  if (this._options.tabClicked)
    if (this._options.tabClicked(currentNode) === false) return false;

  Array.prototype.map.call(this._internalVars.tabs, (element) => {
    if (element === currentNode) {
      element.classList.add("active");
    } else {
      element.classList.remove("active");
    }
  });

  Array.prototype.map.call(this._internalVars.panels, (element, i) => {
    if (i === index) {
      openPanel.call(this, element);
    } else {
      closePanel.call(this, element);
    }
  });
}

/**
 * openInitialTab()
 * Opens tab content for tab set by initialTabOpen
 */
function openInitialTab() {
  let tabIndex = this._options.initialTabOpen - 1;

  Array.prototype.map.call(this._internalVars.tabs, (element, i) => {
    if (i === tabIndex) {
      element.classList.add("active");
    } else {
      element.classList.remove("active");
    }
  });

  Array.prototype.map.call(this._internalVars.panels, (element, i) => {
    if (i === tabIndex) {
      openPanel.call(this, element);
    } else {
      closePanel.call(this, element);
    }
  });
}


/**
 * openPanel()
 * Opens panel at the same index as the clicked tab and hides the other panels
 */
function openPanel(element) {
  element.classList.add("active");
}

/**
 * closePanel()
 * closes the past in panel
 */
function closePanel(element) {
  element.classList.remove("active");
}

/**
 * toggles the component (hide/display).
 */
function toggleComponent() {
  var node = this._internalVars.node;
  /* con-sum-on */
  if (node.classList) {
    if (!node.classList.contains('hidden')) {
      node.classList.add("hidden");
      if (document.querySelector('#wrapper').classList.contains('consolidated-summary-enabled')) {
        document.querySelector('#wrapper').classList.remove('consolidated-summary-enabled');
      }
      if (document.querySelector('#wrapper').classList.contains('pinned-consolidated-summary')) {
        document.querySelector('#wrapper').classList.remove('pinned-consolidated-summary');
        if (document.querySelector('#consolidated-summary-component').classList.contains('pinned')) {
          document.querySelector('#consolidated-summary-component').classList.remove('pinned');
        }
      }

      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
        if (document.querySelector('#to-top').classList.contains('consolidated-summary-enabled')) {
          document.querySelector('#to-top').classList.remove('consolidated-summary-enabled');
        }
        if (document.querySelector('#to-top').classList.contains('pinned-consolidated-summary')) {
          document.querySelector('#to-top').classList.remove('pinned-consolidated-summary');
          if (document.querySelector('#consolidated-summary-component').classList.contains('pinned')) {
            document.querySelector('#consolidated-summary-component').classList.remove('pinned');
          }
        }

      }
      if (document.querySelector('.docked-real-time-message-wrapper') !== null && document.querySelector('.docked-real-time-message-wrapper') !== 'undefined') {
        let dockedMsgArray = document.querySelectorAll('.docked-real-time-message-wrapper');
        Array.prototype.forEach.call(dockedMsgArray, (element) => {
          if (element.classList.contains('con-sum-on')) {
            if (element.hasAttribute('id')) {
              element.classList.remove('con-sum-fifty-fix');
            }
            element.classList.remove('con-sum-on');
          }
        });
      }

    } else {
      node.classList.remove("hidden");
      if (!document.querySelector('#wrapper').classList.contains('consolidated-summary-enabled')) {
        document.querySelector('#wrapper').classList.add('consolidated-summary-enabled');
      }
      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
        if (!document.querySelector('#to-top').classList.contains('consolidated-summary-enabled')) {
          document.querySelector('#to-top').classList.add('consolidated-summary-enabled');
        }
      }
      if (document.querySelector('.docked-real-time-message-wrapper') !== null && document.querySelector('.docked-real-time-message-wrapper') !== 'undefined') {
        let dockedMsgArray = document.querySelectorAll('.docked-real-time-message-wrapper');
        Array.prototype.forEach.call(dockedMsgArray, (element) => {
          if (!element.classList.contains('con-sum-on')) {
            if (element.hasAttribute('id')) {
              element.classList.add('con-sum-fifty-fix');
            }
            element.classList.add('con-sum-on');
          }
        });
      }
    }
  }
}

/**
 * Method to set local variables.
 */
function setLocalVars() {
  if (this._internalVars.contentType === 'string') {
    this._internalVars.node = document.querySelector(this._options.content);
  } else if (this._internalVars.contentType === 'domNode') {
    this._internalVars.node = this._options.content;
  }
  this._internalVars.wrapper = this._internalVars.node.querySelector(".consolidated-summary-wrapper");

  this._internalVars.verticalTabs = this._internalVars.node.querySelector('.consolidated-summary-content-tabs');
  this._internalVars.tabs = this._internalVars.verticalTabs.querySelectorAll('.tab');
  this._internalVars.panels = this._internalVars.verticalTabs.querySelectorAll('.panel');
  this._internalVars.plogComponent = this._internalVars.node.querySelector(".plog");
  this._internalVars.plogBtn = this._internalVars.node.querySelector(".plog-btn");
  this._internalVars.plogForm = this._internalVars.node.querySelector(".policy-note-input-form");
  this._internalVars.plogSendBtn = this._internalVars.node.querySelector(".plog-input-bar .send-btn");

}

export default ConsolidatedSummary;


// WEBPACK FOOTER //
// ./src/js/geico-design-kit/components/ConsolidatedSummary.js